import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HTTPService } from 'src/app/services/http.service';
import { PermissionServices } from 'src/app/services/permission.services';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { UserConfigServices } from 'src/app/services/user-config.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { ThemeService } from 'src/app/services/theme.service';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { WebhookNewItemComponent } from './webhook-new-item/webhook-new-item.component';
import { WebhookDebugLogComponent } from './webhook-edit/webhook-debug-log/webhook-debug-log.component';
import { WebhookThreadListComponent } from './webhook-threadlist-component/webhook-threadlist.component';
import { threadInfo, threadInfoDetail } from 'src/app/interfaces/threadInfo';
import { WebHookCommonServices } from './webhook-services/webhook-commom.services';


export interface FlowStep{
    name:string;
    type:string;
    data:any;
}

/*
 * Módulos NG-ZORRO usados no template: NzCollapseModule, NzSelectModule,
 * NzBadgeModule, NzInputModule, NzCardModule, NzSwitchModule,
 * NzDropDownModule, NzFloatButtonModule, NzSpinModule, NzGridModule,
 * NzButtonModule, NzIconModule, NzDividerModule, NzToolTipModule.
 */
@Component({
    selector: 'webhook-creator',
    templateUrl: './webhook-creator.component.html',
    styleUrl: './webhook-creator.component.scss',
    standalone: false
})
export class WebhookCreatorComponent implements OnInit, AfterViewInit, OnDestroy{

  idconf;
  name;
  codemktp;
  namemarketplace;
  status;
  tipo
  mktpworkflow:any[] = [];
  mktpworkflow_temp:any[] = [];
  sub2: Subscription;
  sub3: Subscription;
  gridMode = true;
  canInsert:Boolean = false;
  canEdit:Boolean = false;

  threadBehaivor = new BehaviorSubject<{obs:threadInfoDetail[],loadingThread:boolean}>({obs:[],loadingThread:false});


  inputFilter:FormControl<string> = new FormControl();
  /** true quando há filtro ativo (colore o ícone do painel) */
  filterActiveState = false;
  filterStatus:FormControl<string> = new FormControl();
  filterActive:FormControl<string> = new FormControl();
  filterCompany:FormControl<string> = new FormControl();
  filterContract:FormControl<string> = new FormControl();
  filterMarketplace:FormControl<string> = new FormControl();
  filterEnvironment:FormControl<string> = new FormControl();

  loading = false;
  /** spinner (nz-spin) da grade de cards */
  loadingData = false;
  userConfig:{workRefresh:boolean} = {
      workRefresh: false
  };

  multiList:{key:string,name:string}[] = [
    {
      key:'S',
      name:'Múltiplos Contextos'
    },
    {
      key:'N',
      name:'Contexto Único'
    }
  ];

  enviromentList:{key:string,name:string}[] = [
    {
      key:'1',
      name:'Produção'
    },
    {
      key:'2',
      name:'Homologação'
    }];


  companyList:{key:string,name:string}[] = [];
  contractList:{key:string,name:string}[] = [];
  marketPlaceList:{key:string,name:string}[] = [];

  activeList:{key:string,name:string}[] = [
    {
      key:'S',
      name:'Ativo'
    },
    {
      key:'N',
      name:'Inativo'
    }
  ];

  statusList:{key:string,name:string}[] = [
      {
        key:'RUNNABLE',
        name:"Executando"
      },
      {
        key:'BLOCKED',
        name:"Bloqueado"
      },
      {
        key:'TIMED_WAITING',
        name:"Esperando"
      },
      {
        key:'STOPPED',
        name:"Parado"
      }
  ];


  @ViewChild('scrollcontainer') private scrollContainer:ElementRef;
  items:FlowStep[] = [{
    name: 'Logger',
    type: 'log',
    data: {
      name: 'Log',
      icon: { name: 'log-icon', color: 'blue' },
      config: {
        message: null,
        severity: null
      }
    }
  }];
  controle:{key:string,value:any}[] = [];
  insert: any;
  data: { evento: string; row: any; formGroup: any; };
  mktpcfgcompany: Object[] = [];
  mktpcfgcompany_temp: object[] = [];
  interval: NodeJS.Timeout;
  canView: Boolean = true;
  threads: threadInfo[] = [];
  timeOut: NodeJS.Timeout;
  worker: Worker;
  canDelete: Boolean;
  selectedItem: any;
  filterValue: string='';
  threadInterval: NodeJS.Timeout;

  constructor(private http:HTTPService,
      private modal: NzModalService,
      private message: NzMessageService,
      private uas:UserAuthenticationServices,
      private userPermission:PermissionServices,
      public cd:ChangeDetectorRef,
      public breakpointObserver: BreakpointObserver,
      public ucs:UserConfigServices,
      public ThemeService:ThemeService,
      public ls:LanguageServices,
      public whServices:WebHookCommonServices,
      private destroyRef: DestroyRef
      ) {
        this.ls.setDefaultLanguage();
      }


  ngOnDestroy(): void {
    if ( this.worker!= null ){
      this.worker.terminate();
    }
    if ( this.threadInterval != null){
      clearInterval(this.threadInterval);
    }
  }



  ngAfterViewInit(){
    if ( this.canView){
      this.loadData(null).then(r=>{
          this.loadServices();
      });
    }
  }

  loadServices() {
        /*//ta-webhook/rest/snippetServices/listOfServices*/

  }



  openLog(item){

    this.modal.create({
                    nzTitle: this.ls.instant('webhook.log.title',{idconf: item['IDCONF'], name: item['NAME']}),
                    nzContent: WebhookDebugLogComponent,
                    nzWidth: '90%',
                    nzStyle: { top: '5px', maxHeight: 'calc( 100vh - 10px)', display: 'flex','flex-direction': 'column' },
                    nzBodyStyle: { overflow: 'auto',  display: 'flex','flex-direction': 'column', height: '100%' },
                    nzMaskClosable: false,
                    nzKeyboard: false,
                    nzClosable: true,
                    nzData: {
                        flowData: {
                            idconf: item['IDCONF'],
                        },
                    },
                    nzFooter:null
    });
  }


  openThread(item){
    this.selectedItem = item;
    this.modal.create({
                    nzTitle: this.ls.instant('webhook.threadlist.title'),
                    nzContent: WebhookThreadListComponent,
                    nzWidth: '90%',
                    nzStyle: { maxHeight: 'calc( 100vh - 10px)' },
                    nzBodyStyle: { overflow: 'auto',  display: 'flex','flex-direction': 'column', height: '100%' },
                    nzMaskClosable: false,
                    nzKeyboard: false,
                    nzClosable: true,
                    nzData: this.threadBehaivor.asObservable(),
                    nzFooter:null,
                    nzCentered: true
    });
  }

  setListOfThreads(item){

     const list:threadInfoDetail[] = [];

     Object.keys(this.threads).forEach(serverName=>{

        let threads:threadInfo[] = this.threads[serverName] as threadInfo[];

        for ( var thread of threads ){
            if ( thread.name.startsWith("IntegracaoMarketPlaceJobThread")){
                let idconf = thread.name.split('_')[1];

                if ( idconf == item['IDCONF']){
                    list.push({
                        servername:serverName,
                        codecompany:thread.name.split('_')[4],
                        codemktp:thread.name.split('_')[2],
                        idjob:thread.name.split('_')[6],
                        threadName:thread.name,
                        status:thread.status,
                        isInterrupted: thread.isInterrupted,
                        stack: thread.stack
                    });
                }
            }
          }
      });
      return list;
  }

  editarDados(item){
      this.gridMode = false;
      this.selectedItem = item;
  }


  loadData(item) {
    return new Promise((resolve,reject)=>{
      this.loadingData = true;

      let reload = false;
      if ( item != null){
          reload = true;
      }
      let ob = {
        entityName:"Mktpcfg",
        sql:`SELECT
                    A.IDCONF,
                    A.NAME,
                    C.CODECONTRACT,
                    C.CONTRACTNAME,
                    A.CODECOMPANY,
                    B.NAME CODECOMPANY_NAME,
                    A.CODEMKTP,
                    D.NAME CODEMKTP_NAME,
                    A.ACTIVE,
                    E.SVGICON,
                    A.ENVIRONMENT ENVIRONMENT,
                    A.CODEMKTPDEST,
                    A.SCHEDULE,
                    A.PREFERENCES,
                    (SELECT MAX(SEQUENCE) FROM MKTPCFI CFI (NOLOCK) WHERE CFI.IDCONF=A.IDCONF AND CFI.ACTIVE='S') AS VERSION
              FROM MKTPCFG A (NOLOCK)
                                          INNER JOIN MKTPCOMPANIES B (NOLOCK) ON A.CODECOMPANY=B.CODECOMPANY
                                          LEFT JOIN MKTPCONTRACT C (NOLOCK) ON B.CODECONTRACT=C.CODECONTRACT
                                          INNER JOIN MKTPLACES D (NOLOCK) ON A.CODEMKTP=D.CODEMKTP
                                          LEFT OUTER JOIN MKTPLACESCONF E (NOLOCK) ON D.CODEMKTP=E.CODEMKTP
              WHERE  ${this.uas.user.profile=='ADMIN' ? '0=0': "EXISTS ( SELECT 1 FROM MKTPCFGCOMPANY AA WHERE A.IDCONF=AA.IDCONF AND AA.CODECOMPANY IN ("+this.uas.getCompanies()+"))" }
              AND ${reload? ' A.IDCONF = '+item["IDCONF"]: "0=0"}
              AND NEWMODE='S'`

      }

      this.sub2 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(async data=>{
        this.loadingData = false;
        let confs:Object[] = data['SQL'];
        if ( reload ){
          if ( this.mktpworkflow.length > 0 ){
            let index = this.mktpworkflow.findIndex(idx=>idx['IDCONF'] == item['IDCONF']);
            if ( index > -1 ){
              this.mktpworkflow[index] = this.transformLineData(confs)[0];
            }else{
              if  ( confs!= null && confs.length > 0 ){
                this.mktpworkflow.push(this.transformLineData(confs)[0]);
              }
            }
          }
        }else{
          this.mktpworkflow = this.transformLineData(confs);
        }

        this.mktpworkflow_temp = this.mktpworkflow;
        this.loadLists();
        this.filterData();


        resolve(true);

      },error=>{
          this.loadingData = false;
          this.message.error('Falha ao carregar as integrações.');
          resolve(false);
      });
    });
  }

  private distinctList(field: string, nameField: string): { key: string, name: string }[] {
    return Array.from(new Set(this.mktpworkflow_temp.map(item => item[field])))
      .map(d => ({ key: d, name: this.mktpworkflow_temp.find(x => x[field] == d)[nameField] }))
      .sort((data, data2) => {
        if (data.name > data2.name) return 1;
        if (data.name < data2.name) return -1;
        return 0;
      });
  }

  loadLists(){
      this.marketPlaceList = this.distinctList('CODEMKTP', 'CODEMKTP_NAME');
      this.companyList = this.distinctList('CODECOMPANY', 'CODECOMPANY_NAME');
      this.contractList = this.distinctList('CODECONTRACT', 'CONTRACTNAME');
      this.enviromentList = this.distinctList('ENVIRONMENT', 'ENVIRONMENT');
  }



  getBadge(control:FormControl){
      if ( ObjectUtil.isNotEmpty(control.value)){
        if ( control.value instanceof Array ){
          return control.value.length;
        }else{
            return 1;
        }
      }
      return null;

  }



  transformLineData(confs: Object[]) {
    let lines:Object[] = [];

    for ( var line of confs){
        let index = lines.findIndex(d=>d['IDCONF']==line['IDCONF']);
        if ( index == -1 ){
            let ob = {
                IDCONF: line['IDCONF'],
                NAME: line['NAME'],
                CODEMKTP: line['CODEMKTP'],
                CODEMKTP_NAME: line['CODEMKTP_NAME'],
                ACTIVE: line['ACTIVE'],
                activeBOO: line['ACTIVE']=='S'? true: false,
                CODECOMPANY:line['CODECOMPANY'],
                CODECOMPANY_NAME: line['CODECOMPANY_NAME'],
                CODECONTRACT: line['CODECONTRACT'],
                CONTRACTNAME:line['CONTRACTNAME'],
                SVGICON:line['SVGICON'],
                ENVIRONMENT:line['ENVIRONMENT'],
                CODEMKTPDEST:line['CODEMKTPDEST'],
                SCHEDULE:line['SCHEDULE'],
                PREFERENCES:line['PREFERENCES'],
                VERSION: line['VERSION']
            }
            lines.push(ob);
        }else{
            (lines[index]['DATA'] as Object[]).push(
              {
                IDCONF: line['IDCONF'],
                NAME: line['NAME'],
                CODEMKTP: line['CODEMKTP'],
                CODEMKTP_NAME: line['CODEMKTP_NAME'],
                ACTIVE: line['ACTIVE'],
                activeBOO: line['ACTIVE']=='S'? true: false,
                CODECOMPANY:line['CODECOMPANY'],
                CODECOMPANY_NAME: line['CODECOMPANY_NAME'],
                CODECONTRACT: line['CODECONTRACT'],
                CONTRACTNAME:line['CONTRACTNAME'],
                SVGICON:line['SVGICON'],
                ENVIRONMENT:line['ENVIRONMENT'],
                CODEMKTPDEST:line['CODEMKTPDEST'],
                SCHEDULE:line['SCHEDULE'],
                PREFERENCES:line['PREFERENCES'],
                VERSION: line['VERSION']
              }
            );
        }
    }
    return lines;
  }

  updateFilter(event){
    this.filterValue = (event.target as HTMLInputElement).value;
    this.filterData();
  }

  ngOnInit(){

    this.canEdit = this.userPermission.checkPermissionSession('MKTPCFG','edit');
    this.canInsert = this.userPermission.checkPermissionSession('MKTPCFG','insert');
    this.canView = this.userPermission.checkPermissionSession('MKTPCFG','view');
    this.canDelete = this.userPermission.checkPermissionSession('MKTPCFG','delete');

    this.filterStatus.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data=>this.checkData('STATUS',data));
    this.filterActive.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data=>this.checkData('ACTIVE',data));
    this.filterCompany.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data=>this.checkData('CODECOMPANY',data));
    this.filterMarketplace.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data=>this.checkData('CODEMKTP',data));
    this.filterContract.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data=>this.checkData('CODECONTRACT',data));
    // o filtro de ambiente existia na tela mas nunca foi ligado — corrigido
    this.filterEnvironment.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data=>this.checkData('ENVIRONMENT',data));

    //this.createWorker();
  }

  fetchAndPostToWorker() {
      if (!this.canView) return;

      this.loading = true;
      const list = this.selectedItem ? this.setListOfThreads(this.selectedItem) : [];
      this.threadBehaivor.next({ obs: list, loadingThread: this.loading });

      this.whServices.getThreads().then(data=>{
            const payload = {
              cfg: this.mktpworkflow_temp,
              threads: data
            };
            this.worker.postMessage(payload);
      })
  }


  createWorker(){

    if (typeof Worker !== 'undefined') {
      // Create a new
      this.worker = new Worker(new URL('./webhook-creator-worker-service.worker.ts', import.meta.url));
      this.worker.onmessage = ({ data }) => {

          if (data?.cfg?.length > 0) {
            setTimeout(()=>{
              this.mktpworkflow_temp = data.cfg;
              this.threads = data.threads;
              this.filterData();
              if ( this.selectedItem !=null){
                let list = this.setListOfThreads(this.selectedItem);
                this.loading = false;
                this.threadBehaivor.next({obs:list,loadingThread:this.loading});
              }
            },100);
          }
      };

      this.fetchAndPostToWorker();


    } else {
      console.log("Não suportado Worker");
    }

    this.threadInterval = setInterval(() => {

      if (this.gridMode && this.canView) {
        this.fetchAndPostToWorker();
      }


    },10000);
  }

  editProperties(item){
    this.addNewItem(
        this.ls.instant('workflow.edit.properties'),
        item
    )
  }

  addNewItem(title:string = this.ls.instant('workflow.insert.new'), editItem = null){
      this.modal.create({
            nzTitle:  title,
            nzClosable: false,
            nzContent: WebhookNewItemComponent,
            nzData: { editItem },
            nzOkText: this.ls.instant('confirm'),
            nzOkDanger: false,
            nzCancelText: this.ls.instant('cancel'),
            nzMask:editItem==null? false:true,
            nzStyle: { top: '5px', maxHeight: '90vh', display: 'flex','flex-direction': 'column' },
            nzBodyStyle: { overflow: 'auto',  display: 'flex','flex-direction': 'column', height: '100%' },
            nzWidth: '60%',
            nzOnOk: (component) => {
                  return component?.save().then(createdValue=>{
                    this.loadData(createdValue).then(d=>{
                        if ( editItem == null ){
                          let item = this.mktpworkflow.find(d=>d.IDCONF == createdValue['IDCONF']);
                          if (item!= null ){
                            this.editarDados(item);
                          }
                        }

                    });
                  });

            }
          });

  }

  checkData(tipo,data){

    let index = this.controle.findIndex(d=>d.key == tipo);

    if ( ObjectUtil.isNotEmpty(data)){
      if ( index  == -1 ){
          this.controle.push({key:tipo,value:data});
      }else{
        this.controle[index].value = data;
      }
    }else{
      if ( index  > -1 ){
        this.controle.splice(index,1);
      }
    }
    this.filterActiveState = this.controle.length > 0 || ObjectUtil.isNotEmpty(this.inputFilter.value);

    this.filterData();
  }


  filterData(){

    let array  = this.mktpworkflow_temp;

    if (this.filterValue != null && this.filterValue != ''){
      this.filterActiveState = true;
      array = array.filter(data=>{
        return data.NAME.toUpperCase().indexOf(this.filterValue.toUpperCase()) > -1 ? true : false||
                String(data.IDCONF).toUpperCase().indexOf(this.filterValue.toUpperCase()) > -1 ? true : false
      });
    }

    this.mktpworkflow  = array.filter(line=>{
      let canShow:{key:string,show:boolean}[]  = [];
      for ( var con of this.controle){
        let tipo = con.key;
        let data:Object[] = con.value;

        if ( line[tipo] == null ){
          for ( var d of data){
            if ((line['DATA'] as Object[])?.findIndex(data=>data[tipo] ==d)  > -1 ){
                if ( canShow.findIndex(d=>d.key==tipo) == -1){
                  canShow.push({key:tipo,show:true});
                }
            }
          }
        }else{
            for ( var d of data){
              if ( line[tipo] == d){
                if ( canShow.findIndex(d=>d.key==tipo) == -1){
                  canShow.push({key:tipo,show:true});
                }
              }
            }
        }
      }

      if ( canShow.length == this.controle.length){
        return true;
      }else{
        return false;
      }
    });

  }


  itemChange(item){

    if ( item['activeBOO']==true){
      item['ACTIVE']='S';
    }else{
      item['ACTIVE']='N';
    }

    this.changeData(item).then(data=>{
        if ( data ){
          this.message.success(this.ls.instant('workflow.success.saved',{version: item['VERSION']}));
        }
    });

  }
  changeData(item) {
    return new Promise((resolve,reject)=>{
      this.loadingData = true;

      let ob = {
        entityName:"Mktpcfg",
        IDCONF: item['IDCONF'],
        ACTIVE: item['ACTIVE']
      }

      this.sub2 = this.http.post(ob,'JsonBrokerServices/save',false,true,true).subscribe(async data=>{
        this.loadingData = false;
        resolve(true);

      },error=>{
          this.loadingData = false;
          // restaura o estado visual do switch em falha
          if ( item['activeBOO']==true){
            item['ACTIVE']='N';
          }else{
            item['ACTIVE']='S';
          }
          item['activeBOO'] = !item['activeBOO'];
          this.message.error('Falha ao salvar a alteração.');
          resolve(false);
      });
    });
  }
}
